import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Checkbox } from '../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const FilterSidebar = ({
  filters,
  onFilterChange,
  categories,
  onClearAll
}) => {
  // Sort options with labels
  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'price_asc', label: 'Price: Low to High' },
    { value: 'price_desc', label: 'Price: High to Low' },
    { value: 'name_asc', label: 'Name: A-Z' },
    { value: 'name_desc', label: 'Name: Z-A' }
  ];

  // Handle category checkbox changes
  const handleCategoryChange = (categoryValue, checked) => {
    if (checked) {
      onFilterChange('category', categoryValue);
    } else {
      onFilterChange('category', '');
    }
  };

  return (
    <aside className="hidden lg:block w-[280px] flex-shrink-0 self-start sticky top-24">
      <div className="bg-white rounded-lg shadow-md p-6 max-h-[calc(100vh-7rem)] overflow-y-auto">
        <h2 className="text-xl font-bold text-gray-900 mb-6">Filters</h2>

        <Accordion type="multiple" defaultValue={["category", "sort"]} className="space-y-2">

          {/* Category Section */}
          <AccordionItem value="category" className="border-b border-gray-200">
            <AccordionTrigger className="text-sm font-semibold text-gray-700 hover:text-brand-blue">
              <span className="flex items-center gap-2">
                <span>Category</span>
              </span>
            </AccordionTrigger>
            <AccordionContent className="pt-3 pb-4">
              <div className="space-y-3">
                {categories.map((cat) => (
                  <div key={cat.value} className="flex items-center space-x-2">
                    <Checkbox
                      id={`category-${cat.value}`}
                      checked={filters.category === cat.value}
                      onCheckedChange={(checked) => handleCategoryChange(cat.value, checked)}
                    />
                    <Label
                      htmlFor={`category-${cat.value}`}
                      className="text-sm text-gray-700 cursor-pointer hover:text-brand-blue flex-1"
                    >
                      {cat.label}
                    </Label>
                  </div>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>



          {/* Sort Section */}
          <AccordionItem value="sort" className="border-b border-gray-200">
            <AccordionTrigger className="text-sm font-semibold text-gray-700 hover:text-brand-blue">
              <span className="flex items-center gap-2">
                <span>Sort By</span>
              </span>
            </AccordionTrigger>
            <AccordionContent className="pt-3 pb-4">
              <RadioGroup
                value={filters.sort || 'newest'}
                onValueChange={(value) => onFilterChange('sort', value)}
                className="space-y-3"
              >
                {sortOptions.map((option) => (
                  <div key={option.value} className="flex items-center space-x-2">
                    <RadioGroupItem value={option.value} id={`sort-${option.value}`} />
                    <Label
                      htmlFor={`sort-${option.value}`}
                      className="text-sm text-gray-700 cursor-pointer hover:text-brand-blue flex-1"
                    >
                      {option.label}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        <Button
          variant="outline"
          className="w-full mt-6 text-red-600 hover:text-red-700 hover:bg-red-50 border-red-300"
          onClick={onClearAll}
        >
          Clear All Filters
        </Button>
      </div>
    </aside>
  );
};

export default FilterSidebar;

